/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_UnarchiveInputs */

const en_audio_unarchive = /** @type {(inputs: Audio_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore audio`)
};

const es_audio_unarchive = /** @type {(inputs: Audio_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar audio`)
};

/**
* | output |
* | --- |
* | "Restore audio" |
*
* @param {Audio_UnarchiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_unarchive = /** @type {((inputs?: Audio_UnarchiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_UnarchiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_unarchive(inputs)
	return en_audio_unarchive(inputs)
});